// src/components/dependants/sharedNote.component.jsx
import React, { useEffect, useState } from "react";
// import DragBox from "../../Universals/DragBox/dragBox.component";
import DragBox2026 from "../../Universals/DragBox/DragBox2026/dragBox2026.component.jsx";
import { getUserFromToken } from "../../../utils/functions.ts";
// NEW: import the editor in PascalCase
import SharedNoteEditor from "./sharedNoteEditor.component.jsx";

const SharedNotes = () => {
  const notesEndpoint = "https://www.fbxchange.com/ReactPHP/notes.php";
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(null);
  const [saveError, setSaveError] = useState(null);

  const [note, setNote] = useState(null);
  const [draft, setDraft] = useState(null);
  const [isDirty, setIsDirty] = useState(false);
  const [team, setTeam] = useState("");

  useEffect(() => {
    let alive = true;
    const fetchLatest = async () => {
      const user = await getUserFromToken();
      if (!user) {
        setLoading(false);
        setFetchError("User not found");
        return;
      }
      setTeam(user.team || "");
      setLoading(true);
      setFetchError(null);
      try {
        const res = await fetch(notesEndpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            scriptName: "getMostRecentNoteByTeam",
            team: user.team || "",
            scout: user.scout || "",
          }),
        });

        const data = await res.json().catch(() => ({}));
        if (!res.ok || data?.ok === false) {
          throw new Error(data?.message || "Failed to load shared note.");
        }

        const incoming =
          data?.note ||
          (Array.isArray(data?.notes) && data.notes.length > 0 ? data.notes[0] : null);

        if (alive) {
          setNote(incoming || null);
          setDraft(incoming ? { ...incoming } : null);
          setIsDirty(false);
          setLoading(false);
        }
      } catch (err) {
        if (alive) {
          setFetchError(err?.message || "Unable to fetch note.");
          setLoading(false);
        }
      }
    };

    fetchLatest();
    return () => {
      alive = false;
    };
  }, []);

  return (
    <DragBox2026
      storageKey="SHARED_NOTE_POSITION"
      defaultPos={{ x: 58, y: 95 }}
      title={`${draft?.title ?? "Shared Note"}${
        draft?.lastUpdated ? ` - ${draft?.lastUpdated}` : ""
      } - Updated by [${draft?.lastEditBy || "Unknown"}]`}
      minWidth={1400}
      maxWidth={1400}
      zIndex={500}
      showReset={true}
      closeButtonText="Close without Saving"
    >
      <div className="card shadow-sm" style={{ borderRadius: 16, overflow: "hidden" }}>
        <div className="card-header d-flex align-items-center justify-content-between">
          <div>
            <strong>Shared Note</strong> <span className="text-muted">({team})</span>
          </div>
          {isDirty && <span className="badge text-bg-warning">Unsaved changes</span>}
        </div>

        <div className="card-body">
          {loading && <div className="text-muted small">Loading the latest note…</div>}
          {!loading && fetchError && <div className="alert alert-danger mb-3">{fetchError}</div>}
          {!loading && !fetchError && !draft && (
            <div className="alert alert-info mb-0">
              No shared notes were found for team <strong>{team}</strong>.
            </div>
          )}
          {!loading && !fetchError && draft && (
            <>
              {/* FIX: Use PascalCase component */}
              <SharedNoteEditor note={draft} />
              {saveError && <div className="alert alert-danger mt-3 mb-0">{saveError}</div>}
            </>
          )}
        </div>
      </div>
    </DragBox2026>
  );
};

export default SharedNotes;
